/**
 * `beforeinstallprompt` fires at most once per session. We cache the event and
 * notify subscribers so the install button survives route changes and remounts.
 * A listener is also registered early from `index.tsx` so the event is not missed
 * before React mounts.
 */
export interface BeforeInstallPromptEventLike extends Event {
  prompt: () => Promise<void>;
  userChoice: Promise<{ outcome: 'accepted' | 'dismissed' }>;
}

let cachedDeferredPrompt: BeforeInstallPromptEventLike | null = null;
const listeners = new Set<() => void>();

function notify(): void {
  listeners.forEach((fn) => fn());
}

/** For `useSyncExternalStore` — re-renders when the cached prompt changes. */
export function subscribeDeferredInstallPrompt(onStoreChange: () => void): () => void {
  listeners.add(onStoreChange);
  return () => listeners.delete(onStoreChange);
}

export function getDeferredInstallPromptSnapshot(): BeforeInstallPromptEventLike | null {
  return cachedDeferredPrompt;
}

export function setCachedDeferredInstallPrompt(e: BeforeInstallPromptEventLike | null): void {
  cachedDeferredPrompt = e;
  notify();
}

export function clearCachedDeferredInstallPrompt(): void {
  cachedDeferredPrompt = null;
  notify();
}
